const accounts = (state = {}, action) => {
  switch (action.type) {
    case "SET_ACCOUNTS_DATA":
      return action.data;
    default:
      return state;
  }
};

export default accounts;
